/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { Component } from 'react';
import withRouter from '../../hooks/withRouter';

import {
  VendorManagementProps,
  VendorManagementState,
  VendorManagementViewRendererProps,
} from './types';

import ViewRenderer from './views';

class VendorManagement extends Component<VendorManagementProps, VendorManagementState> {
  constructor(props: VendorManagementProps) {
    super(props);

    this.state = {
      sample: '',
    };
  }

  getProps = (): VendorManagementViewRendererProps => {
    const {
      sample,
    } = this.state;

    return {
      sample,
    };
  };

  render() {
    const viewProps: VendorManagementViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(VendorManagement);
